import { useEffect, useState, useMemo } from 'react';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { useRouter } from '@atlassian/react-resource-router';
import { SECTION_ID } from '../../common/constants.tsx';

// eslint-disable-next-line jira/ff/inline-usage
export const isCrossTeamPlanningTemplateExperimentEnabled = () =>
	expValEquals('second_premium_template_experiment', 'cohort', 'variation');

export const useStack = () => {
	const [{ route }] = useRouter();

	const stackFromRouteName = useMemo(() => {
		if (route.name.startsWith('plan-settings')) {
			return [SECTION_ID.SETTINGS];
		}

		return [];
	}, [route.name]);

	const [stack, setStack] = useState<string[]>(stackFromRouteName);

	useEffect(() => {
		setStack(stackFromRouteName);
	}, [stackFromRouteName]);

	return [stack, setStack] as const;
};

export const useNestedAppOpen = () => {
	const [stack] = useStack();
	const [value, setValue] = useState<boolean>(stack.length > 0);

	useEffect(() => {
		setValue(stack.length > 0);
	}, [stack]);

	return [value, setValue] as const;
};
